import { PersonalFormErrorJSON } from '../models/personal-form';

export const formPersonalErrors: PersonalFormErrorJSON = {
    firstName: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    lastName: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    phoneNumber: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    countryCode: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
